import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_NoteTemplate } from '../../../../../_entity/note-template/ModuleFE_NoteTemplate.js';
import './Renderer_NoteTemplateHeader.scss';
export class Renderer_NoteTemplateHeader extends ComponentSync {
    __onNoteTemplatesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.noteTemplate?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ noteTemplate: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.noteTemplate?._id)
            state.noteTemplate = ModuleFE_NoteTemplate.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'note-template-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'note-template-header__title', children: this.state.noteTemplate?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const noteTemplate = this.state.noteTemplate;
        if (!noteTemplate?.title || noteTemplate.title === noteTemplate.label)
            return;
        return _jsx("span", { className: 'note-template-header__sub-title', children: noteTemplate.title });
    };
}
//# sourceMappingURL=Renderer_NoteTemplateHeader.js.map